import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
 */
import React from 'react';
import { compose } from 'recompose';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { getStore } from '../../lib/store/store';
import withDevice from '../with-device/with-device';
import withStrings from '../with-strings/with-strings';
import withModalState from '../with-modal-state/with-modal-state';
import ComponentByNode from './utils/ComponentByNode';
import ConfirmModal from '../content-block/confirm-modal/ConfirmModal';
import CmsConsumer from './utils/CmsConsumer';
import MojoJumpPage from './renderers/mojo-jump-page/MojoJumpPage';
export var CmsContent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CmsContent, _React$PureComponent);

  var _super = _createSuper(CmsContent);

  function CmsContent(props) {
    var _this;

    _classCallCheck(this, CmsContent);

    /* this component state is purely for TDD in Jest */
    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "childCount", 0);

    _defineProperty(_assertThisInitialized(_this), "getChildKey", function () {
      return "".concat(_this.props.eleId, "_content_").concat(_this.childCount++);
    });

    _defineProperty(_assertThisInitialized(_this), "closeMojoJumpPage", function () {
      _this.setState({
        openMojoJumpPage: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setModalNavigationDetails", function (_ref) {
      var navigationUrl = _ref.navigationUrl,
          dataDisplayType = _ref.dataDisplayType,
          dataLinkType = _ref.dataLinkType,
          openMojoJumpPage = _ref.openMojoJumpPage;

      if (openMojoJumpPage) {
        _this.setState({
          mojoNavigationUrl: navigationUrl,
          openMojoJumpPage: openMojoJumpPage
        });
      } else {
        _this.setState({
          navigationUrl: navigationUrl,
          dataDisplayType: dataDisplayType,
          dataLinkType: dataLinkType
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "convertToComponents", function (childrenNodes) {
      var _this$props = _this.props,
          children = _this$props.children,
          device = _this$props.device,
          openModal = _this$props.openModal,
          getString = _this$props.getString,
          dataRef = _this$props.dataRef,
          footnotes = _this$props.footnotes,
          textNodeWrapperElement = _this$props.textNodeWrapperElement,
          templateType = _this$props.templateType;

      if (childrenNodes) {
        var _assertThisInitialize = _assertThisInitialized(_this),
            convertToComponents = _assertThisInitialize.convertToComponents,
            getChildKey = _assertThisInitialize.getChildKey;

        return Array.prototype.map.call(childrenNodes, function (domNode, i) {
          //eslint-disable-line
          var childNodes = domNode.childNodes,
              nodeName = domNode.nodeName,
              nodeType = domNode.nodeType,
              textContent = domNode.textContent;

          if (nodeType === 3) {
            var Element = textNodeWrapperElement;
            return textNodeWrapperElement ? /*#__PURE__*/React.createElement(Element, {
              key: getChildKey()
            }, textContent) : /*#__PURE__*/React.createElement(React.Fragment, {
              key: getChildKey()
            }, textContent);
          }

          var componentByNode = new ComponentByNode(domNode, children);
          var Component = componentByNode.get(device, openModal, _this.setModalNavigationDetails, getString, dataRef, // cms template references,
          footnotes, templateType);
          var nodeAttributes = componentByNode.getNodeAttributes();
          var childComponents = childNodes && childNodes.length ? convertToComponents(childNodes) : null;

          if (Component) {
            return /*#__PURE__*/React.createElement(Component, _extends({
              key: getChildKey()
            }, nodeAttributes), childComponents);
          }

          return /*#__PURE__*/React.createElement(nodeName.toLowerCase(), _objectSpread({
            key: getChildKey()
          }, nodeAttributes), childComponents);
        });
      } else {
        return null;
      }
    });

    _this.state = {
      navigationUrl: null,
      dataDisplayType: null,
      dataLinkType: null,
      mojoNavigationUrl: null,
      openMojoJumpPage: false
    };
    _this.store = getStore();
    _this.contentToRender = _this.getConvertedContent();
    return _this;
  }

  _createClass(CmsContent, [{
    key: "getConvertedContent",
    value: function getConvertedContent() {
      var content = this.props.content;

      if (content) {
        var containerRef = document.createElement('div');
        containerRef.innerHTML = DOMPurify.sanitize(content);
        return this.convertToComponents(containerRef.childNodes);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isModalOpen = _this$props2.isModalOpen,
          closeModal = _this$props2.closeModal,
          content = _this$props2.content;
      var _this$state = this.state,
          navigationUrl = _this$state.navigationUrl,
          dataDisplayType = _this$state.dataDisplayType,
          dataLinkType = _this$state.dataLinkType,
          openMojoJumpPage = _this$state.openMojoJumpPage,
          mojoNavigationUrl = _this$state.mojoNavigationUrl;
      return content ? /*#__PURE__*/React.createElement(React.Fragment, {
        key: this.getChildKey
      }, this.contentToRender, navigationUrl && dataDisplayType && /*#__PURE__*/React.createElement(ConfirmModal, {
        isOpen: isModalOpen,
        onFrameworkClose: closeModal,
        navigationUrl: navigationUrl,
        dataDisplayType: dataDisplayType,
        dataLinkType: dataLinkType
      }), openMojoJumpPage && /*#__PURE__*/React.createElement(MojoJumpPage, {
        isOpen: openMojoJumpPage,
        onFrameworkClose: this.closeMojoJumpPage,
        mojoNavigationUrl: mojoNavigationUrl
      })) : null;
    }
  }]);

  return CmsContent;
}(React.PureComponent);
CmsContent.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isModalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  device: PropTypes.object,
  openModal: PropTypes.func,
  getString: PropTypes.func,
  dataRef: PropTypes.object,
  eleId: PropTypes.string
};
export default compose(CmsConsumer, withDevice, withModalState, withStrings)(CmsContent);